import React from 'react';
import propTypes from 'prop-types';

/**
 * This components are using to minimize the panel
 * @props onTogglePanelVisibility
 * @props onReload
 * @props
 */

const MinimizedPanel = (props) => {
  const { onTogglePanelVisibility, title, isCollapsed } = props;
  return (
    <div className="card-header">
      <div className="row">
        <div className="col-md-6">
          <p>{title}</p>
        </div>
        <div className="col-md-6">
          {props.children ? (
            <p className="text-right">{props.children}</p>
          ) : (
            <h5 className="text-right">
              <i
                onClick={onTogglePanelVisibility}
                className={`fa ${
                  isCollapsed ? 'fa-window-maximize' : 'fa-window-minimize'
                }`}></i>
            </h5>
          )}
        </div>
      </div>
    </div>
  );
};
/**
 * Proptypes
 * @type { onTogglePanelVisibility, title, isCollapsed }
 */
MinimizedPanel.propTypes = {
  onTogglePanelVisibility: propTypes.func,
  title: propTypes.string,
  isCollapsed: propTypes.bool
};

export default MinimizedPanel;
